import {
  Avatar,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Chip,
  Tab,
  TabPanel,
  Tabs,
  TabsBody,
  TabsHeader,
  Tooltip,
  Typography
} from "@material-tailwind/react";
import React, {useEffect, useRef, useState} from "react";
import {AgentPanelConsultationMenu} from "./agents_panel_consultation_menu";
import {AgentPanelServiceMenu} from "./agents_panel_service_menu";
import {BsStarFill} from "react-icons/bs";
import {getBranch} from "../../services/branch/branch";
import {TagIcon} from "@heroicons/react/24/solid";
import {getAgentsListDetail} from "../../services/agent/agent";
import {getFileUrl} from "../../config";
import persianNumberFormat from "../../helper/PersianNumberFormat";

export function AgentPanel({agent_id, setAgentId, branch_id, setBranchId, type}) {
  const [agentsList, setAgentsList] = useState([]);
  const [activeTab, setActiveTab] = useState(false);
  const [agentId,] = useState(agent_id ? agent_id : null);
  const [branchId,] = useState(branch_id ? branch_id : null);

  const [dataLoaded, setDataLoaded] = useState(false);

  const tabBodyRef = useRef(null);

  const avatar = '/assets/blank_profile.jpg';

  const fieldTitlesOrder = [
    "امور ثبتی", "مالی و مالیاتی", "حقوقی", "بیمه", "تامین مالی و سرمایه گذاری", "توسعه کسب و کار"
  ];

  async function prepareData(agentsListDetail) {
    if (!agentsListDetail) {
      return agentsListDetail
    }

    const result = await getBranch(branch_id);
    if (result.status === 200) {
      const {branch} = result.data;
      const field_id = branch ? branch.field_id : null;
      let selectedField = null;
      for (let field of agentsListDetail) {
        if (field.field_id === field_id) {
          selectedField = field;
          setActiveTab(field.field_title);
          break;
        }
      }

      if (!selectedField) {
        return
      }

      let selectedAgent = null;
      for (let agent of selectedField.agent_list_detail) {
        if (agent.agent_id === parseInt(agent_id)) {
          selectedAgent = agent;
          break;
        }

      }

      if (!selectedAgent) {
        return
      }

      const index = selectedField.agent_list_detail.indexOf(selectedAgent);
      selectedField.agent_list_detail.splice(index, 1);
      // Insert the selected agent at the first position of the list
      selectedField.agent_list_detail.unshift(selectedAgent);
      return agentsListDetail
    }
    return agentsList;
  }

  async function getData(type) {
    const result = await getAgentsListDetail(type);
    if (result.status === 200) {
      const {agentsListDetail} = result.data;
      agentsListDetail.sort((a, b) => {
        return fieldTitlesOrder.indexOf(a.field_title) - fieldTitlesOrder.indexOf(b.field_title);
      });

      return agentsListDetail || null;
    }
  }

  useEffect(() => {
    async function loadAgentsList() {
      let agentsListDetail;
      agentsListDetail = await getData(type);
      setAgentsList(agentsListDetail)

      if (branch_id && agent_id) {
        agentsListDetail = await prepareData(agentsListDetail);
      } else {
        setActiveTab(agentsListDetail ? agentsListDetail[0].field_title : null);
      }

      setAgentsList(agentsListDetail)

    }

    loadAgentsList();
  }, []);


  useEffect(() => {
    if (agentId && branchId && agentsList?.length > 0) {
      prepareData();
    }
  }, [agentId, branchId, agentsList]);

  const handleTabChange = (newTab) => {
    // alert(newTab)
    setActiveTab(newTab);

    if (tabBodyRef.current) {
      tabBodyRef.current.scrollTo(tabBodyRef.current.scrollWidth, tabBodyRef.current.scrollHeight, {
        block: "nearest",
        behavior: 'smooth'
      });
    }
  };

  if (agentsList?.length > 0 && activeTab) {
    return (
      <>
        <Tabs value={activeTab} className="w-full h-full bg-white border-r-4">

          <TabsHeader
            className="flex bg-transparent max-w-fit min-w-[32rem] overflow-x-scroll"
            indicatorProps={{
              className: "bg-gray-900/10 shadow-none !text-gray-900",
            }}
          >
            {agentsList.map(({field_title, field_id}) => (
              <Tab key={field_title} value={field_title} className="max-w-fit min-w-fit p-2"
                   onClick={() => handleTabChange(field_title)}
              >
                {field_title}
              </Tab>
            ))}
          </TabsHeader>
          <TabsBody className="overflow-x-scroll" ref={tabBodyRef} animate={{
            initial: {x: 250},
            mount: {x: 0},
            unmount: {x: 250},
          }}
          >

            {agentsList.map(({field_title, field_id, agent_list_detail}) => (
              <TabPanel key={field_title} value={field_title} className="flex flex-row gap-4"
              >
                {agent_list_detail.map(({
                                          agent_id,
                                          name,
                                          photo,
                                          branch_title,
                                          rate,
                                          experience,
                                          speciality,
                                          province_title,
                                          discount,
                                          installment
                                        }) => (
                  <div className="flex flex-col" key={agent_id}>
                    <Card
                      className={`border-blue-gray-300 border-2 w-60 h-100 flex-grow ${agentId == agent_id ? "bg-blue-100" : ""}`}
                    >
                      <CardHeader className="bg-transparent border-none shadow-none mt-4">
                        <div className="flex flex-col justify-center">
                          <div className="flex flex-row justify-end mb-4 gap-x-2 h-6">
                            {installment &&
                              <Chip
                                variant="ghost"
                                color="blue"
                                size="sm"
                                value="قسطی"
                                icon={
                                  <i className="fa fa-handshake h-4 w-4" aria-hidden="true"></i>
                                }
                              />
                            }
                            {discount &&
                              <Chip
                                variant="ghost"
                                color="red"
                                size="sm"
                                value="تخفیف دار"
                                icon={
                                  <TagIcon className="h-4 w-4"/>
                                }
                              />
                            }
                          </div>
                          <div className="flex flex-row justify-center">
                            <Avatar variant="circular" alt="tania andrew"
                                    className="z-10 border-none"
                                    withBorder={true} size="xxl"
                                    src={photo ? getFileUrl(photo) : avatar}
                            />
                          </div>
                        </div>
                      </CardHeader>
                      <CardBody className="text-center mt-2 border-b border-spacing-x-px border-none">
                        <div
                          style={{whiteSpace: 'nowrap', direction: 'rtl', textAlign: 'left'}}
                          className="flex flex-row overflow-hidden justify-center">
                          <Tooltip content={name}>
                            <Typography variant="h5" color="blue-gray" className="mb-2 font-bold">
                              {name}
                            </Typography>
                          </Tooltip>
                        </div>
                        <div className="flex flex-row overflow-hidden h-8 justify-center">
                          <Tooltip content={`${type === 'consultation' ?
                            "مشاور " :
                            "خدمات دهنده "} ${speciality}`}>
                            <Typography className="font-medium text-blue-gray-600">
                              {`${type === 'consultation' ?
                                "مشاور " :
                                "خدمات دهنده "} ${speciality}`}
                            </Typography>
                          </Tooltip>
                        </div>
                        <div className="flex flex-row justify-center">
                          <Typography className="font-medium text-blue-gray-500 mt-4">
                            {`امتیاز: ${persianNumberFormat(rate)}`}
                          </Typography>
                          <BsStarFill className="mt-5 mr-2" color="#FFDF00"/>
                        </div>
                        <div className="flex flex-row h-8 justify-center">
                          <Typography className="font-medium text-blue-900 mt-4">
                            {`سابقه فعالیت: ${persianNumberFormat(experience)} سال`}
                          </Typography>
                        </div>
                        <div className="flex flex-row h-8 justify-center">
                          <Typography className="font-medium text-blue-900 mt-4">
                            {`مکان فعالیت: ${province_title}`}
                          </Typography>
                        </div>
                      </CardBody>
                      <CardFooter className="w-full">
                        <div className="flex flex-row w-full justify-center">
                          {type === 'consultation' ?
                            <AgentPanelConsultationMenu
                              agentId={agent_id}
                              branch_id={agentId == agent_id ? branch_id : null}
                              fieldId={field_id}
                              setAgentId={setAgentId}
                              setBranchId={setBranchId}
                            />
                            :
                            <AgentPanelServiceMenu
                              agent_name={name}
                              agentId={agent_id}
                              fieldId={field_id}
                              branch_id={agentId == agent_id ? branch_id : null}
                            />
                          }
                        </div>
                        {/*<Button className="w-44" variant="outlined" onClick={() => {*/}
                        {/*  setAgentId(agent_id)*/}
                        {/*  setSelectedAgentId(agent_id)*/}
                        {/*  setSelectedFieldId(field_id)*/}

                        {/*}}>*/}
                        {/*  {type === 'consultation' ?*/}
                        {/*    "دریافت مشاوره" :*/}
                        {/*    "استعلام قیمت"*/}
                        {/*  }*/}
                        {/*</Button>*/}
                      </CardFooter>
                    </Card>
                  </div>
                ))}
              </TabPanel>
            ))}
          </TabsBody>
        </Tabs>
      </>
    );
  }
}